module.exports = __webpack_public_path__ + "static/media/logo.3570a548.png";